import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Row, Col, Form as BoostrapForm } from "react-bootstrap";
import { Form, Formik, Field } from "formik";
import {
  httpPutEmailAdmin,
  httpPostEmailAdmin,
  httpDeleteEmailAdmin,
} from "../../../../service/httpClient";

import {
  UPLOAD_ICON,
  WORD_ICON,
  TEXT_ICON,
  PDF_ICON,
  EXCEL_ICON,
} from "../../../../assets/js/image";

import {
  getFormFields,
  getFormValidations,
  FormikRadioField,
} from "../../../Common/FormFields";
import * as Yup from "yup";

const activeConfig = {
  name: "active",
  type: "radio",
  length: 12,
  selectOptions: [
    {
      optionValue: "Yes",
      optionName: "Active",
    },
    {
      optionValue: "No",
      optionName: "Inactive",
    },
  ],
};

const formFieldConfig = [
  {
    name: "touchPointDesc",
    type: "plainText",
    label: "Touch Point:",
    layout: "Row",
    labelWidth: 4,
    controlWidth: 6,
    length: 10,
  },
  {
    name: "fulfillmentTypeDesc",
    type: "plainText",
    label: "Vendor Fulfillment Type:",
    layout: "Row",
    labelWidth: 4,
    controlWidth: 6,
    length: 10,
  },
  {
    name: "vendorConnectionDesc",
    type: "plainText",
    label: "Vendor Connection:",
    layout: "Row",
    labelWidth: 4,
    controlWidth: 6,
    length: 10,
  },
  {
    name: "sellingChannel",
    type: "plainText",
    label: "Selling Channel:",
    layout: "Row",
    labelWidth: 4,
    controlWidth: 6,
    length: 10,
  },
  {
    name: "recipients",
    required: true,
    type: "multiSelect",
    label: "Recipient(s):",
    layout: "Row",
    labelWidth: 2,
    controlWidth: 10,
    length: 12,
    selectOptions: [
      {
        optionValue: "Primary",
        optionName: "Vendor-Primary",
      },
      {
        optionValue: "Technical",
        optionName: "Vendor-Technical/EDI",
      },
      {
        optionValue: "CustomerService",
        optionName: "Vendor-Customer",
      },
      {
        optionValue: "Shipping",
        optionName: "Vendor-Shipping",
      },
      {
        optionValue: "Merchant",
        optionName: "Merchant",
      },
      {
        optionValue: "vdfMerchantOpsManager",
        optionName: "VDF Merchant Manager",
      },
      {
        optionValue: "vdfOpsAdmin",
        optionName: "VDF Admin",
      },
      {
        optionValue: "vdfOpsPipelineOwner",
        optionName: "Pipeline Owner",
      },
      {
        optionValue: "accountsPayableAdmin",
        optionName: "AP Admin",
      },
      {
        optionValue: "bigticketAdmin",
        optionName: "BT Admin",
      },
      {
        optionValue: "Other",
        optionName: "Vendor-Other",
      },
    ],
    validation: Yup.array().min(
      1,
      "Email Recipient field must have atleast 1 entry."
    ),
  },
  {
    name: "cc",
    required: true,
    type: "multiSelect",
    label: "CC'(s):",
    layout: "Row",
    labelWidth: 2,
    controlWidth: 10,
    length: 12,
    selectOptions: [
      {
        optionValue: "Primary",
        optionName: "Vendor-Primary",
      },
      {
        optionValue: "Technical",
        optionName: "Vendor-Technical/EDI",
      },
      {
        optionValue: "CustomerService",
        optionName: "Vendor-Customer",
      },
      {
        optionValue: "Shipping",
        optionName: "Vendor-Shipping",
      },
      {
        optionValue: "Merchant",
        optionName: "Merchant",
      },
      {
        optionValue: "vdfMerchantOpsManager",
        optionName: "VDF Merchant Manager",
      },
      {
        optionValue: "vdfOpsAdmin",
        optionName: "VDF Admin",
      },
      {
        optionValue: "vdfOpsPipelineOwner",
        optionName: "Pipeline Owner",
      },
      {
        optionValue: "accountsPayableAdmin",
        optionName: "AP Admin",
      },
      {
        optionValue: "bigticketAdmin",
        optionName: "BT Admin",
      },
      {
        optionValue: "Other",
        optionName: "Vendor-Other",
      },
    ],
    validation: Yup.array().min(1, "Email Cc field must have atleast 1 entry."),
  },
  {
    name: "subject",
    required: true,
    type: "text",
    label: "Email Subject:",
    layout: "Row",
    labelWidth: 2,
    controlWidth: 10,
    length: 12,
    validation: Yup.string().required("Email subject field is required."),
  },
  {
    name: "body",
    required: true,
    type: "richText",
    label: "Email Body:",
    layout: "Row",
    labelWidth: 2,
    controlWidth: 10,
    length: 12,
    validation: Yup.string()
      .required("Email body field is required.")
      .test((value) => {
        if (!value) {
          return new Yup.ValidationError(
            "Email body can not be blank.",
            undefined,
            "body"
          );
        }
        return true;
      }),
  },
];
const fileUploadConfig = {
  name: "attachments",
  required: false,
  type: "fileUpload",
  label: "Attachment(s):",
  layout: "Row",
  labelWidth: 2,
  controlWidth: 10,
  length: 12,
};

const validationRules = getFormValidations(formFieldConfig);
const FileUploadControl = ({
  fileUploadConfig,
  emailToEdit,
  updateFileExtention,
  setIsHitService,
  setFileAttachments,
}) => {
  const { name, label, labelWidth, layout, controlWidth } = fileUploadConfig;
  const value = emailToEdit.attachments;

  const [hightlight, setHightlight] = useState(false);
  const [files, setFiles] = useState(null);
  const [fileListItem, setFileListItem] = useState(null);
  const [userMessage, setUserMessage] = useState(null);
  const [overwriteFlagStatus, setOverwriteFlagStatus] = useState(false);
  const fileInputRef = useRef(null);
  const fileBrowseRef = useRef(null);
  const [selectdFiles, setSelectdFiles] = useState(null);
  const extension = [
    ".DOC",
    ".DOCX",
    ".JPG",
    ".JPEG",
    ".PNG",
    ".ODT",
    ".PDF",
    ".XLS",
    ".XLSX",
  ];

  useEffect(() => {
    if (value && value.length > 0) {
      setFileListItem(value.map((x) => x));
    }
  }, [value]);

  const openFileDialog = () => {
    fileInputRef.current.click();
  };

  const duplicateCheck = (files) => {
    let fileCheck = false;
    const deft = fileListItem || [];
    const val = files || [];

    if (deft.length > 0) {
      const findDuplicat = (existingItem) => {
        for (let i = 0; i < files.length; i++) {
          if (files[i].name === existingItem.fileName) {
            return true;
          }
        }
        return false;
      };
      for (let i = 0; i < deft.length; i++) {
        const res = findDuplicat(deft[i]);
        if (res) {
          fileCheck = true;
          setFiles(files);
          return true;
        } else {
          fileCheck = false;
        }
      }
    }
    return fileCheck;
  };

  const updateFileListItem = (newFileObjectArr) => {
    let existingItemList = fileListItem || [];

    newFileObjectArr.forEach((item) => {
      const existRow = existingItemList.find(
        (rec) => rec.fileName === item.name
      );
      if (!existRow) {
        existingItemList.push({
          fileName: item.name,
          donwloadUrl: "",
          fileSize: `${item.size}`,
        });
      }
    });

    setFileListItem([...existingItemList]);
    setFileAttachments([...existingItemList]);
  };

  const onFilesAdded = (e) => {
    e.preventDefault();
    const fileEventList = e?.target?.files || [];
    const fileArray = fileListToArray(fileEventList);
    setSelectdFiles(fileArray);

    let extFlag = true;
    let arr = [];
    for (let i = 0; i < fileArray.length; i++) {
      extFlag = extension.some((el) => {
        return fileArray[i].name.toLowerCase().endsWith(el.toLowerCase());
      });
      if (extFlag) {
        arr.push(fileArray[i]);
      }
    }

    if (arr.length !== fileArray.length) {
      updateFileExtention(true);
      if (arr.length === 0) return;
    }
    const isDuplicat = duplicateCheck(arr);
    if (isDuplicat) {
      const nonDuplicatFiles = arr;
      setUserMessage(true);
      setOverwriteFlagStatus(true);
      if (nonDuplicatFiles && nonDuplicatFiles.lenth === 0) {
        return false;
      } else {
        arr = nonDuplicatFiles;
      }
    }

    let existingFiles = files ? [...files] : [];

    arr.forEach((x) => {
      const fndRow = existingFiles.find((item) => item.name === x.name);
      if (!fndRow) {
        existingFiles.push(x);
      }
    });
    const id = emailToEdit.id;
    httpPostEmailAdmin(arr, id).then((response) => {
      setIsHitService(true);
    });
    setFiles([...existingFiles]);
    updateFileListItem([...existingFiles]);
  };

  const onDragOver = (event) => {
    event.preventDefault();
    setHightlight(true);
  };

  const onDragLeave = (event) => {
    setHightlight(false);
  };

  const onDrop = (event) => {
    event.preventDefault();
    const fileEvents = event.dataTransfer.files;
    const fileArray = fileListToArray(fileEvents);
    setSelectdFiles(fileArray);
    let existingFiles = files ? [...files] : [];
    let extFlag = true;
    let arr = [];
    for (let i = 0; i < fileArray.length; i++) {
      extFlag = extension.some((el) => {
        return fileArray[i].name.toLowerCase().endsWith(el.toLowerCase());
      });
      if (extFlag) {
        arr.push(fileArray[i]);
      }
    }
    if (arr.length !== fileArray.length) {
      updateFileExtention(true);
      if (arr.length === 0) return;
    }
    const isDuplicat = duplicateCheck(arr);
    if (isDuplicat) {
      const nonDuplicatFiles = arr;
      setUserMessage(true);
      setOverwriteFlagStatus(true);
      if (nonDuplicatFiles && nonDuplicatFiles.lenth === 0) {
        return false;
      } else {
        arr = nonDuplicatFiles;
      }
    }

    arr.forEach((x) => {
      existingFiles.push(x);
    });

    const id = emailToEdit.id;
    httpPostEmailAdmin(arr, id).then((response) => {
      setIsHitService(true);
    });
    setFiles([...existingFiles]);
    setHightlight(false);
    updateFileListItem([...existingFiles]);
  };

  const fileListToArray = (list) => {
    const array = [];

    for (let i = 0; i < list.length; i++) {
      array.push(list.item(i));
    }
    return array;
  };

  const fileFormateIcon = (fileName) => {
    if (!fileName) return;
    const fileDetails = fileName.split(".");
    if (fileDetails[1] === "txt") {
      return (
        <TEXT_ICON
          style="fileupload_previewList_icon"
          altText="txt"
          id="text_icon"
        />
      );
    } else if (fileDetails[1] === "docx" || fileDetails[1] === "doc") {
      return (
        <WORD_ICON
          style="fileupload_previewList_icon"
          altText="txt"
          id="word_icon"
        />
      );
    } else if (fileDetails[1] === "pdf") {
      return (
        <PDF_ICON
          style="fileupload_previewList_icon"
          altText="txt"
          id="text_icon"
        />
      );
    } else if (
      fileDetails[1] === "xlsx" ||
      fileDetails[1] === "xls" ||
      fileDetails[1] === "ods" ||
      fileDetails[1] === "csv"
    ) {
      return (
        <EXCEL_ICON
          style="fileupload_previewList_icon"
          altText="txt"
          id="excel_icon"
        />
      );
    }
  };

  const deleteFile = (e, index) => {
    e.preventDefault();

    let fileList = [...fileListItem];
    const fileNameToDelete = fileList[index].fileName;

    const id = emailToEdit.id;
    httpDeleteEmailAdmin(fileList[index], id).then((res) => {
      setIsHitService(true);
    });
    fileList.splice(index, 1);

    if (fileList.length > 0) {
      setFileListItem([...fileList]);
      setFileAttachments([...fileList]);
    } else {
      setFileListItem(null);
      setFileAttachments(null);
    }
    let existingFileObjectList = files ? [...files] : [];
    let newFileObjectList = existingFileObjectList.filter(
      (x) => x.name !== fileNameToDelete
    );

    if (newFileObjectList.length > 0) {
      setFiles([...newFileObjectList]);
    } else {
      setFiles(null);
    }
  };

  const handleOverwrite = () => {
    let existingFiles = files ? [...files] : [];
    const fileArray = files || [];

    const arr = [];
    let extFlag = true;
    for (let i = 0; i < fileArray.length; i++) {
      extFlag = extension.some((el) => {
        return fileArray[i].name.toLowerCase().endsWith(el.toLowerCase());
      });
      if (extFlag) {
        arr.push(fileArray[i]);
      }
    }

    arr.forEach((x) => {
      const fndRow = existingFiles.find((item) => item.name === x.name);
      if (!fndRow) {
        existingFiles.push(x);
      }
    });
    const id = emailToEdit.id;
    httpPostEmailAdmin(arr, id).then((response) => {
      setIsHitService(true);
    });
    setFiles([...existingFiles]);
    updateFileListItem([...existingFiles]);
    setOverwriteFlagStatus(false);
    setUserMessage(null);
  };
  const handleOverWritClose = () => {
    setOverwriteFlagStatus(false);
    setUserMessage(null);
  };

  const overWriteMessage = () => {
    const filesNames = () => {
      const duplicateFiles =
        selectdFiles &&
        selectdFiles.map((item) => {
          const file = fileListItem.find(
            (existFile) => existFile.fileName === item.name
          );
          if (file) {
            return `${file.fileName} `;
          }
        });
      return duplicateFiles;
    };
    return (
      <Modal
        className="exports-modal"
        show={overwriteFlagStatus}
        onHide={handleOverWritClose}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Duplicate Files</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          File {filesNames()} already exist, would you like to overwrite ?
        </Modal.Body>
        <Modal.Footer>
          <Button className="button-primary-md" onClick={handleOverwrite}>
            OK
          </Button>
          <Button className="button-primary-md" onClick={handleOverWritClose}>
            cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <div style={{ width: "100%" }}>
      <BoostrapForm className="row">
        <div className="col-2">{label}</div>
        <div className="col-10">
          <div
            className={`fileupload_dropzone ${
              hightlight ? "fileupload_highlight" : ""
            }`}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
            onClick={openFileDialog}
          >
            <input
              ref={fileInputRef}
              className="fileupload_fileInput"
              type="file"
              multiple
              onChange={(e) => {
                onFilesAdded(e);
                e.target.value = "";
              }}
            />
            <div className="fileupload_iconImageWrapper">
              <UPLOAD_ICON
                style="fileupload_iconImage"
                altText="upload"
                id="upload_icon"
              />
            </div>
            <div className="fileupload_iconText">
              Drag and Drop the file to upload
            </div>
          </div>
          <input
            ref={fileBrowseRef}
            type="file"
            id="browseFile"
            style={{ display: "none" }}
            onChange={(e) => {
              onFilesAdded(e);
              e.target.value = "";
            }}
            multiple
          />
          <button
            onClick={(e) => {
              e.preventDefault();
              fileBrowseRef.current && fileBrowseRef.current.click();
            }}
            className="fileupload_browseBtn"
          >
            Browse file
          </button>
          {fileListItem && (
            <div className="fileUpload_previewList_container">
              {fileListItem.map((file, index) => {
                return (
                  <div key={index}>
                    {fileFormateIcon(file.fileName)}
                    <span className="fileupload_previewList_filename">
                      {file.fileName}
                      <span
                        className="fileupload_previewList_deleteIcon"
                        onClick={(e) => deleteFile(e, index)}
                      >
                        X
                      </span>
                    </span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        {userMessage ? overWriteMessage() : ""}
      </BoostrapForm>
    </div>
  );
};

const EmailEditModal = ({
  emailToEdit,
  modalCloseHandler,
  getEmailAdminDetail,
}) => {
  const handleClose = () => {
    if (isHitService) {
      getEmailAdminDetail();
    }
    modalCloseHandler();
  };
  const handleErrorClose = () => {
    setExtensionFlagStatus(false);
  };
  const [errorMessage, setErrorMessage] = useState("");
  const [extensionFlagStatus, setExtensionFlagStatus] = useState(false);
  const [isHitService, setIsHitService] = useState(false);
  const [fileAttachments, setFileAttachments] = useState(
    emailToEdit.attachments
  );

  const submitHandler = (data) => {
    httpPutEmailAdmin(data)
      .then((response) => {
        getEmailAdminDetail();
        modalCloseHandler();
      })
      .catch((error) => {
        setErrorMessage(error.message);
      });
  };
  const fileExtension = [
    ".DOC (or .DOCX)",
    ".JPG (or .JPEG)",
    ".ODT",
    ".PDF",
    ".PNG",
    ".XLS (or .XLSX)",
  ];

  return (
    <Modal show={true} onHide={handleClose} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{emailToEdit.title}</Modal.Title>
      </Modal.Header>
      {errorMessage && (
        <p style={{ textAlign: "center" }} className="errorMessage">
          {errorMessage}
        </p>
      )}
      <Formik
        initialValues={{
          ...emailToEdit,
          filesToUploadList: null,
        }}
        validationSchema={validationRules}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          values.attachments = fileAttachments;
          let dataToSubmit = {
            ...values,
          };
          submitHandler(dataToSubmit);
          setSubmitting(false);
        }}
        render={({
          isSubmitting,
          isValid,
          dirty,
          resetForm,
          setFieldValue,
        }) => (
          <Form
            className="edit_email_modal"
            onChange={(e) => {
              const fieldName = e.target.name;
              const fieldValue = e.target.value;
              if (fieldName === "active") {
                setFieldValue(fieldName, fieldValue, true);
              }
            }}
          >
            <Modal.Body>
              <div
                style={{
                  marginBottom: "-60px",
                  marginRight: 20,
                  float: "right",
                }}
              >
                <FormikRadioField {...activeConfig} />
              </div>
              {extensionFlagStatus ? <div>Extenstion problem </div> : ""}

              {extensionFlagStatus && (
                <Modal
                  className="exports-modal"
                  show={extensionFlagStatus}
                  onHide={handleErrorClose}
                  backdrop="static"
                >
                  <Modal.Header>
                    <Modal.Title>Error – File Extension</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="uploadWindow-fileExtensionHeading">
                      Please select a file with one of the following extensions:
                    </div>
                    {fileExtension.map((fileExt) => (
                      <div>{fileExt}</div>
                    ))}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      className="button-primary-md"
                      onClick={handleErrorClose}
                    >
                      OK
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
              {getFormFields(formFieldConfig).map((field) => field)}
              <FileUploadControl
                emailToEdit={emailToEdit}
                fileUploadConfig={fileUploadConfig}
                updateFileExtention={(flag) => setExtensionFlagStatus(flag)}
                setIsHitService={(status) => setIsHitService(status)}
                setFileAttachments={(files) => setFileAttachments(files)}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                style={{ float: "right" }}
                className="button-primary-md"
                type="submit"
                disabled={!isValid || !dirty || isSubmitting}
              >
                MODIFY
              </Button>
            </Modal.Footer>
          </Form>
        )}
      />
    </Modal>
  );
};

export default EmailEditModal;
